import { ReactEventHandler } from 'react';

export default function wrapEvent(
  theirHandler: ReactEventHandler | undefined,
  ourHandler: ReactEventHandler,
): ReactEventHandler {
  return event => {
    if (theirHandler) {
      theirHandler(event);
    }
    if (!event.defaultPrevented) {
      return ourHandler(event);
    }
  };
}
